document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("tab-container")) {
    class TabContainer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const tabButtons = this.querySelectorAll(".tab-button");
        const tabContainerTitle = this.querySelector(".tab-container-title");

        tabButtons.forEach((tabButton) => {
          const handleTabInteraction = (event) => {
            const buttonText = tabButton.innerText;
            if (tabContainerTitle) {
              tabContainerTitle.innerText = buttonText;
            }

            event.stopPropagation();
            const currentTabContentId = tabButton.getAttribute("data-tab-content");
            const currentTabContent = this.querySelector(currentTabContentId);

            // Remove 'is-active' class from all tab buttons
            tabButtons.forEach((button) => {
              button.classList.remove("is-active");
            });

            // Add 'is-active' class to the clicked tab button
            tabButton.classList.add("is-active");

            // Remove 'is-active' class from all tab contents
            this.querySelectorAll(".tab-content").forEach((tabContent) => {
              tabContent.classList.remove("is-active");
            });

            // Add 'is-active' class to the corresponding tab content
            if (currentTabContent) {
              currentTabContent.classList.add("is-active");
            }
          };

          // Attach both click and touch event listeners to the button
          tabButton.addEventListener("click", handleTabInteraction);
          tabButton.addEventListener("touchstart", handleTabInteraction);
        });
      }
    }

    customElements.define("tab-container", TabContainer);
  }
});
